const getSkorRentang = (dataPredikat, id) => {
  const predikat = dataPredikat.find((p) => p.id === id);
  return predikat ? predikat.rentang_skor : 0;
};

export default getSkorRentang;
